<template>
  <div class="change-state-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Merge Person Records
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500" v-if = "!error">
          All of the {{ modelPrettified }}s that have been selected will be merged into one record.<br>
          Select correct values for the resulting record.
        </p>
      </div>
    </div>
    <div class="modal-body" v-if = "selectionsLoaded">
      <div class=" grid grid-cols-2 my-6" v-if="!error">
        <template v-for = "item in formFields">
          <template v-if = "selectOptions[item.field]">
            <div  :key = "item.label">{{item.label}}</div>
            <div  :key = "item.field">
              <multiselect
                v-model = "selectedItems[item.field]"
                label = "label"
                trackBy = "value"
                :options = "selectOptions[item.field]"
                :placeholder = "entityPlaceholder"
                :loading = "!selectionsLoaded"
              >
                <template v-if="item.isImage" slot="singleLabel" slot-scope="props"><img class="option__image" :src="props.option.label"></template>
                <template v-if="item.isImage" slot="option" slot-scope="props"><img class="option__image" :src="props.option.label"></template>

              </multiselect>
            </div>
          </template>
        </template>
      </div>
      <div v-if="error" class=" align-middle text-center">
        {{errorMessage}}
      </div>
      <div class="action-buttons" >
        <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
        <button v-if="!error" type="button" class="btn btn-primary" @click="submit" >Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        selectedItems: { },
        selectOptions: { },
        selectionsLoaded: false,
        sourceData: [],
        targetIndex: null,
        error: null,
        processing: false,
      }
    },
    computed: {
      entityPlaceholder () {
        return this.selectionsLoaded ? 'Select an item' : 'Loading selections...'
      },
      modelPrettified () {
        if (this.model == 'Church') {
          return 'Churches';
        }
        return startCase(this.model)
      },
      config(){
        console.log(this.options)
        return this.options.config
      },
      formFields() {
        return this.config.form_fields ? this.config.form_fields : []
      },
      selectedValues() {
        let rv = {}
        let items = this.selectedItems
        Object.keys(items).forEach( key => rv[key] = items[key] ? items[key].value : '')
        return rv
      },
      errorMessage(){
        switch (this.error) {
          case 'target':
            return this.model == 'Person' ? 'Only one record can have an associated User!' :  `Only one record can have a: ${this.config.target}`
            break;
          default:
            return null
            break;
        }
      }

    },
    methods: {
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing) {
          this.processing = true
          BulkActionService.merge(this.ids, this.model, this.selectedValues.target_id, this.selectedValues)
            .then(resp => {
              FlashMessages.success(`Records sucessfully merged`, 'Success')
              this.close()
            })
            .catch(resp => {
              FlashMessages.error(`Failed to merge records. Please try again later.`, 'Error')
              this.close()
            })
        }
      },
      loadSelectOptions() {
        let flds = this.formFields
        let tgt = this.config.target
        console.log(flds)
        axios.get(`${this.config.url}.json?merge_ids=${this.ids}`)
          .then(rep => {
            this.sourceData = rep.data
            this.sourceData.forEach((ent, indx) => {
              if (tgt && ent[tgt] && ent[tgt].toString().trim().length > 0 ) {
                this.setTarget(this, indx, ent.id)
              }
              flds.forEach(fld => this.addOption(fld, ent) )
            });
            if (!this.targetIndex){
              this.targetIndex = 0
              this.target_id = this.sourceData[0].id
            }
            this.setInitialValues(this.sourceData[this.targetIndex])
            this.selectionsLoaded = true
            console.log(this.selectOptions)
            console.log(this.selectedItems)
          })
      },
      setTarget(context, indx, id){
          if (context.targetIndex == null) {
            context.selectedItems.target_id={value: id}
            context.targetIndex=indx
          } else if (context.config.only_one_target)
          {
            context.error='target'
          }
      },
      addOption(fObj, dObj){
        var lbl = dObj[fObj.field]
        var val = fObj.value ? dObj[fObj.value] : lbl
        if ( lbl && lbl.trim() ) {
          if (!this.selectOptions[fObj.field]){
            this.selectOptions[fObj.field] = [{ label: lbl, value: val }]
          } else if (!this.selectOptions[fObj.field].find( item => item.label === lbl) ){
            this.selectOptions[fObj.field].push({ label: lbl, value: val })
          }
        }
      },
      setValue(fieldRec, srcRec){
          var valField = fieldRec.value ? fieldRec.value : fieldRec.field
          var options = this.selectOptions[fieldRec.field]
          this.selectedItems[fieldRec.field] = options ? options.find(itm => itm.value === srcRec[valField]) : null
      },
      setInitialValues(sRec) {
        this.formFields.forEach( ent=> this.setValue(ent, sRec) )
      },
      extractValue(itm){
        let obj = {}
        obj[itm.field] = itm.value
        return obj
      },

    },
    created () {
      this.loadSelectOptions()
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  .change-state-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
